// Mock data for development (when API is not available)
const generateProducts = () => {
  const products = [];
  let productId = 1;
  
  // Anéis (Rings) - 15 products
  const aneisMaterials = ['Ouro branco 18k', 'Ouro amarelo 18k', 'Ouro rosé 18k', 'Prata 925', 'Platina'];
  const aneisTypes = ['Noivado', 'Aliança', 'Solitário', 'Eternidade', 'Coquetel'];
  
  for (let i = 0; i < 15; i++) {
    const currentId = productId++;
    products.push({
      id: currentId,
      sku: `BMB-AN-${String(i + 1).padStart(3, '0')}`,
      name: `Anel ${aneisTypes[i % aneisTypes.length]} ${i + 1}`,
      category: 'Anéis',
      collection: i % 3 === 0 ? 'Clássica' : i % 3 === 1 ? 'Moderna' : 'Luxo',
      image: `https://picsum.photos/400/400?random=${currentId}`,
      imageSm: `https://picsum.photos/200/200?random=${currentId}`,
      imageMd: `https://picsum.photos/400/400?random=${currentId}`,
      imageLg: `https://picsum.photos/600/600?random=${currentId}`,
      description: `Anel de ${aneisTypes[i % aneisTypes.length].toLowerCase()} com design exclusivo`,
      material: aneisMaterials[i % aneisMaterials.length],
      specifications: {
        weight: `${2.5 + (i * 0.3)}g`,
        stone: i % 2 === 0 ? 'Diamante' : 'Zircônia',
        size: 'Ajustável 14-20',
      },
      availability: 'Disponível',
      isNew: i < 3,
    });
  }
  
  // Brincos (Earrings) - 12 products
  const brincosMaterials = ['Prata 925', 'Ouro branco 18k', 'Ouro amarelo 18k', 'Ouro rosé 18k'];
  const brincosTypes = ['Argola', 'Pérola', 'Diamante', 'Gota', 'Chandelier'];
  
  for (let i = 0; i < 12; i++) {
    const currentId = productId++;
    products.push({
      id: currentId,
      sku: `BMB-BR-${String(i + 1).padStart(3, '0')}`,
      name: `Brincos ${brincosTypes[i % brincosTypes.length]} ${i + 1}`,
      category: 'Brincos',
      collection: i % 3 === 0 ? 'Mar' : i % 3 === 1 ? 'Terra' : 'Céu',
      image: `https://picsum.photos/400/400?random=${currentId}`,
      imageSm: `https://picsum.photos/200/200?random=${currentId}`,
      imageMd: `https://picsum.photos/400/400?random=${currentId}`,
      imageLg: `https://picsum.photos/600/600?random=${currentId}`,
      description: `Brincos ${brincosTypes[i % brincosTypes.length].toLowerCase()} com acabamento premium`,
      material: brincosMaterials[i % brincosMaterials.length],
      specifications: {
        weight: `${1.5 + (i * 0.2)}g`,
        pearl: i % 3 === 0 ? 'Pérola natural 8mm' : null,
        closure: 'Tarraxa borboleta',
      },
      availability: 'Disponível',
      isNew: i < 2,
    });
  }
  
  // Colares (Necklaces) - 10 products
  const colaresMaterials = ['Ouro branco 18k', 'Ouro amarelo 18k', 'Prata 925', 'Ouro rosé 18k'];
  const colaresTypes = ['Ponto de Luz', 'Corrente', 'Choker', 'Longo', 'Pendente'];
  
  for (let i = 0; i < 10; i++) {
    const currentId = productId++;
    products.push({
      id: currentId,
      sku: `BMB-CL-${String(i + 1).padStart(3, '0')}`,
      name: `Colar ${colaresTypes[i % colaresTypes.length]} ${i + 1}`,
      category: 'Colares',
      collection: i % 2 === 0 ? 'Elegância' : 'Casual',
      image: `https://picsum.photos/400/400?random=${currentId}`,
      imageSm: `https://picsum.photos/200/200?random=${currentId}`,
      imageMd: `https://picsum.photos/400/400?random=${currentId}`,
      imageLg: `https://picsum.photos/600/600?random=${currentId}`,
      description: `Colar ${colaresTypes[i % colaresTypes.length].toLowerCase()} sofisticado`,
      material: colaresMaterials[i % colaresMaterials.length],
      specifications: {
        weight: `${5 + (i * 0.5)}g`,
        length: `${40 + (i * 2)}cm`,
        closure: 'Fecho lagosta',
      },
      availability: 'Disponível',
      isNew: i < 2,
    });
  }
  
  // Pulseiras (Bracelets) - 8 products
  const pulseirasMaterials = ['Ouro amarelo 18k', 'Prata 925', 'Ouro branco 18k', 'Ouro rosé 18k'];
  const pulseirasTypes = ['Riviera', 'Elo', 'Berloque', 'Tennis', 'Corda'];
  
  for (let i = 0; i < 8; i++) {
    const currentId = productId++;
    products.push({
      id: currentId,
      sku: `BMB-PL-${String(i + 1).padStart(3, '0')}`,
      name: `Pulseira ${pulseirasTypes[i % pulseirasTypes.length]} ${i + 1}`,
      category: 'Pulseiras',
      collection: i % 2 === 0 ? 'Urban' : 'Classic',
      image: `https://picsum.photos/400/400?random=${currentId}`,
      imageSm: `https://picsum.photos/200/200?random=${currentId}`,
      imageMd: `https://picsum.photos/400/400?random=${currentId}`,
      imageLg: `https://picsum.photos/600/600?random=${currentId}`,
      description: `Pulseira ${pulseirasTypes[i % pulseirasTypes.length].toLowerCase()} artesanal`,
      material: pulseirasMaterials[i % pulseirasMaterials.length],
      specifications: {
        weight: `${8 + (i * 0.8)}g`,
        length: `${17 + i}cm`,
        closure: 'Fecho de segurança',
      },
      availability: 'Disponível',
      isNew: i === 0,
    });
  }
  
  // Talismãs (Charms) - 6 products
  for (let i = 0; i < 6; i++) {
    const currentId = productId++;
    products.push({
      id: currentId,
      sku: `BMB-TL-${String(i + 1).padStart(3, '0')}`,
      name: `Talismã ${['Estrela', 'Lua', 'Sol', 'Coração', 'Trevo', 'Infinito'][i]}`,
      category: 'Talismãs',
      collection: 'Místico',
      image: `https://picsum.photos/400/400?random=${currentId}`,
      imageSm: `https://picsum.photos/200/200?random=${currentId}`,
      imageMd: `https://picsum.photos/400/400?random=${currentId}`,
      imageLg: `https://picsum.photos/600/600?random=${currentId}`,
      description: `Talismã com significado especial`,
      material: i % 2 === 0 ? 'Prata 925' : 'Ouro amarelo 18k',
      specifications: {
        weight: `${1 + (i * 0.2)}g`,
        size: '1.5cm',
        type: 'Pingente',
      },
      availability: 'Disponível',
      isNew: i < 2,
    });
  }
  
  return products;
};

const mockProducts = generateProducts();

const mockCategories = [
  { value: 'anéis', label: 'Anéis', count: 15 },
  { value: 'brincos', label: 'Brincos', count: 12 },
  { value: 'colares', label: 'Colares', count: 10 },
  { value: 'pulseiras', label: 'Pulseiras', count: 8 },
  { value: 'talismãs', label: 'Talismãs', count: 6 },
];

const productService = {
  async getProducts(filters = {}) {
    return new Promise((resolve) => {
      setTimeout(() => {
        let filteredProducts = [...mockProducts];
        
        if (filters.category) {
          filteredProducts = filteredProducts.filter(p => 
            p.category.toLowerCase() === filters.category.toLowerCase()
          );
        }
        
        if (filters.search) {
          filteredProducts = filteredProducts.filter(p => 
            p.name.toLowerCase().includes(filters.search.toLowerCase()) ||
            p.sku.toLowerCase().includes(filters.search.toLowerCase())
          );
        }
        
        resolve({ data: filteredProducts });
      }, 500);
    });
  },

  async getProductById(id) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const product = mockProducts.find(p => p.id === parseInt(id));
        if (product) {
          resolve({ data: product });
        } else {
          reject(new Error('Product not found'));
        }
      }, 300);
    });
  },

  async getCategories() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ data: mockCategories });
      }, 200);
    });
  },

  async getFeaturedProducts() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ data: mockProducts.slice(0, 4) });
      }, 300);
    });
  },

  async getCollections() {
    return new Promise((resolve) => {
      setTimeout(() => {
        // Mock collections data similar to the API structure
        const mockCollections = [
          {
            id: 24002,
            name: 'Joalharia',
            description: 'Joalharia',
            active: true,
            product_count: 0,
            subcollections: [
              { id: 300, name: 'Anéis', description: 'Anéis', parent_id: 24002, product_count: 41, active: true },
              { id: 200, name: 'Brincos', description: 'Brincos', parent_id: 24002, product_count: 50, active: true },
              { id: 100, name: 'Colares', description: 'Colares', parent_id: 24002, product_count: 81, active: true },
              { id: 24008, name: 'Talismãs', description: 'Talismãs', parent_id: 24002, product_count: 15, active: true },
              { id: 400, name: 'Pulseiras', description: 'Pulseiras', parent_id: 24002, product_count: 35, active: true },
              { id: 30003, name: 'Perneiras', description: 'Perneiras', parent_id: 24002, product_count: 1, active: true },
            ]
          },
          {
            id: 30005,
            name: 'Coleção Cápsula',
            description: 'Capsule Collection',
            active: true,
            product_count: 0,
            subcollections: []
          },
        ];
        resolve({ data: mockCollections });
      }, 200);
    });
  },
};

export default productService;